// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-table[data-v-6ad1171e]{padding:0 20px;box-sizing:border-box}.baikeCat .el-select[data-v-6ad1171e]{width:48%;float:left}.ellips2[data-v-6ad1171e]{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden}", ""]);
// Exports
module.exports = exports;
